/*
 * Created on Wed Aug 09 2023
 *
 * Project: BKN_FRONT
 * Copyright (c) 2023 Nttdata
 */
import React from "react";
import {Combobox, ComboboxInput, ComboboxPopover, ComboboxList, ComboboxOption,} from "@reach/combobox";
import usePlacesAutocomplete,{getGeocode, getLatLng} from "use-places-autocomplete";

function Search({panTo}){
    const{
      ready, 
      value, 
      suggestions : {status, data },
      setValue, 
      clearSuggestions,
      } = usePlacesAutocomplete({
      requestOptions:{
        location:{lat : () => 41.4,lng : () => 2.15},
        radius : 200 * 1000,
      },
    });
  
    return (
      <div className = "search">
        
        <Combobox 
          onSelect = {async (address) => {
            setValue(address, false);
            clearSuggestions();
            try{
              const results = await getGeocode({address});
              const { lat, lng } = await getLatLng(results[0]);
              panTo({lat, lng, address});
            }catch(error){
              console.log("error!")
            }
          }}
        >
          <ComboboxInput 
            value={value} 
            onChange = {(e) => {
              setValue(e.target.value);
            }}
            disabled={!ready}
            placeholder = "Introdueixi una adreça/origen"
          />
          <ComboboxPopover>
            <ComboboxList>
              {status === "OK" && 
                data.map(({description},index) => (
                  <ComboboxOption key={index} value={description}/>
              ))}
            </ComboboxList> 
          </ComboboxPopover>
        </Combobox> 
      </div>
    )
  } 
  export default Search;